import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import CookieBanner from "./components/CookieBanner";
import Landing from "./pages/Landing";
import Merci from "./pages/Merci";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import { MentionsLegales, PolitiqueConfidentialite, PolitiqueCookies } from "./pages/Legal";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const ConditionalCookieBanner = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return <CookieBanner />;
};

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/merci" element={<Merci />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/politique-cookies" element={<PolitiqueCookies />} />
        <Route path="*" element={<Landing />} />
      </Routes>
      <ConditionalCookieBanner />
      <Toaster theme="dark" position="top-center" />
    </BrowserRouter>
  );
}
